// extracted by mini-css-extract-plugin
module.exports = {"accordionWrapper":"_f7aec70"};